/* unplugin-vue-components disabled */import { render } from "./ProReportMortar.vue?vue&type=template&id=c15390f8&scoped=true&ts=true"
import script from "./ProReportMortar.vue?vue&type=script&lang=ts"
export * from "./ProReportMortar.vue?vue&type=script&lang=ts"

import "./ProReportMortar.vue?vue&type=style&index=0&id=c15390f8&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15390f8"]])

export default __exports__